export default __webpack_public_path__ + "91552ae9042bc317afda842fbe0d6320.svg";